export default "__VITE_ASSET__BjM4Sklc__"